// extracted by mini-css-extract-plugin
module.exports = {"label":"labeled-value_label__2NdhW","danger":"labeled-value_danger__3Lp2m","success":"labeled-value_success__1ayfw"};